globalThis.backoffice = globalThis.backoffice || {};

backoffice.multipleCheckbox = (function() {
    function multipleCheckbox($html) {
        this.$html = $html;

        this.init();
    }

    multipleCheckbox.prototype = {
        init: function() {
            this.events();
        },
        events: function() {
            var me = this;

            me.$html.on('change', function(e) {
                e.preventDefault();

                var $this = $(this),
                    checkbox_name = me.$html.data("target-name"),
                    $checkboxes   = $("input[type='checkbox'][name='"+checkbox_name+"']");

                if($this.is(":checked")) {
                    $checkboxes.prop("checked", true).trigger('change').uniform();
                } else {
                    $checkboxes.prop("checked", false).trigger('change').uniform();
                }
            })

        }
    }

    return multipleCheckbox;
})();
